import React from "react";
import Stories1 from '../assets/Stories1.png';
import Stories2 from '../assets/Stories2.png';
import Stories3 from '../assets/Stories3.png';
import Stories4 from '../assets/Stories4.png';
import Stories5 from '../assets/Stories5.png';

// Define the data array using the imported assets
const storiesData = [
    { id: 1, image: Stories1, hasVideo: false },
    { id: 2, image: Stories2, hasVideo: true },
    { id: 3, image: Stories3, hasVideo: false },
    { id: 4, image: Stories4, hasVideo: false },
    { id: 5, image: Stories5, hasVideo: false },
];

export default function CustomerStories() {
    return (
        <section className="bg-[#1A73E8] py-20 md:py-28 font-sans w-full overflow-hidden">
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 text-center">
                
                {/* HEADINGS */}
                <p className="text-[12px] md:text-[12px] tracking-[0.15em] font-medium text-white/80 uppercase mb-4">
                    Customer Stories
                </p>
                
                <h2 className="text-[48px] md:text-[48px] lg:text-[56px] font-bold text-white tracking-tight mb-12 md:mb-16">
                    Loved by thousands of salons and spas
                </h2>

                {/* IMAGES CONTAINER */}
                {/* On mobile, it allows horizontal scrolling. On larger screens, it centers them. */}
                <div className="flex flex-nowrap overflow-x-auto md:overflow-visible justify-start md:justify-center items-center gap-4 md:gap-6 pb-6 md:pb-0 scrollbar-hide">
                    {storiesData.map((story) => (
                        <div 
                            key={story.id} 
                            className="relative flex-shrink-0 w-[200px] h-[260px] md:w-[220px] md:h-[280px] lg:w-[240px] lg:h-[300px] rounded-[24px] overflow-hidden shadow-[0_15px_35px_rgba(0,0,0,0.15)] group cursor-pointer"
                        >
                            <img 
                                src={story.image} 
                                alt={`Customer story ${story.id}`} 
                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                            />
                            
                            {/* VIDEO PLAY BUTTON OVERLAY */}
                            {story.hasVideo && (
                                <div className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/20 transition-colors duration-300">
                                    <div className="w-14 h-14 rounded-full border-[1.5px] border-white flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                                        <svg 
                                            className="w-5 h-5 text-white ml-1" 
                                            fill="currentColor" 
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M8 5v14l11-7z" />
                                        </svg>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
}